class PrepareDataForMessage {
  prepareData = (payload) => {
    const payloadData = {
      message_type: payload.message_type
    }

    if (
      payload.message_type === 'location' ||
      payload.message_type === 'file' ||
      payload.message_type === 'image'
    ) {
      payloadData.additional_data = {}
    }

    if (payload.message_type === 'location') {
      payloadData.additional_data['location.latitude'] = payload.additional_data['location.latitude']
      payloadData.additional_data['location.longitude'] = payload.additional_data['location.longitude']
      payloadData.additional_data['location.address'] = payload.additional_data['location.address']
    }

    if (payload.message_type === 'image') {
      payloadData.additional_data['image.key'] = payload.additional_data['image.key']
    }

    if (payload.message_type === 'file') {
      payloadData.additional_data['file.key'] = payload.additional_data['file.key']
    }

    if (payload.message_type === 'text') {
      payloadData.body = payload.body
    }

    return payloadData
  }
}

export default PrepareDataForMessage
